<template>
	<div class="rb-horizontal-scroll">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'RbHorizontalScroll',
		data: () => ({
			targetX: null,
		}),
		props: {
			speed: {
				type: Number,
				default: 100
			},
			focusItem: {
				type: Number,
				default: 0
			}
		},
		watch: {
			focusItem() {
				this.updateFocus();
			}
		},
		mounted() {
			this.$el.addEventListener('wheel', this.onWheel);
			this.$el.addEventListener('scroll', this.onScroll);

			this.$nextTick(() => this.updateFocus());
		},
		beforeDestroy() {
			this.$el.removeEventListener('wheel', this.onWheel);
			this.$el.removeEventListener('scroll', this.onScroll);
		},
		methods: {
			onWheel(e) {

				if (this.targetX === null) this.targetX = this.$el.scrollLeft;

				let delta = e.deltaY / Math.abs(e.deltaY);

				this.targetX += delta * this.speed;
				this.targetX = Math.max(this.targetX, 0);
				this.targetX = Math.min(this.targetX, this.$el.scrollWidth - this.$el.clientWidth);

				if (this.targetX !== this.$el.scrollLeft) {
					this.$el.scrollLeft = this.targetX;

					e.preventDefault();
					e.stopPropagation();
				}
			},
			onScroll() {
				if (this.$el.scrollLeft === this.targetX) {
					this.targetX = null;
				}
			},
			updateFocus() {
				if (this.focusItem >= 0) {
					this.$nextTick(() => {
						if (this.focusItem < this.$el.children.length) {
							this.scrollToElement(this.$el.children[this.focusItem]);
						}
					});
				}
			},
			scrollToElement(el) {
				let scrollAmount = el.offsetLeft;
				const thisBounds = this.$el.getBoundingClientRect();
				const elBounds = el.getBoundingClientRect();

				scrollAmount += (elBounds.width / 2)-(thisBounds.width / 2);

				this.$el.scrollLeft = this.targetX = scrollAmount;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-horizontal-scroll {
		overflow-x: auto;
		overflow-y: hidden;
		white-space: nowrap;
		scroll-behavior: smooth;

		> * {
			display: inline-block;
			margin: 0 5px;

			&:first-child {
				margin-left: 0;
			}

			&:last-child {
				margin-right: 0;
			}
		}
	}


	// Scrollbars

	@include media-breakpoint-down(sm) {
		* {
			&::-webkit-scrollbar {
				width: 0px;
				height: 0px;
			}
			&::-webkit-scrollbar-track {
				background: rgba($dark, .8);
			}
			&::-webkit-scrollbar-thumb {
				box-shadow: inset 0 0 2px rgba($primary, 0.49);
				border: 1px solid rgba($primary-2, 0.26);
			}
		}
	}
</style>
